import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { DATE_EXTEND_FORMAT, freePlanExtendPopType } from '@app/_helpers/constants';
import { StorageHelper } from '@app/_helpers/storage';
import { Utils } from '@app/_helpers/utilities';
import { ConfigurationService } from '@app/_shared/providers/configuration/configuration.service';
import { AuthService } from '@app/modules/auth/provider/auth/auth.service';
import { SocialLoginProvider } from '@app/modules/auth/provider/auth/auth.structs';
import { NotificationsService } from '@app/modules/trading/modules/profile/providers/notifications/notifications.service';
import * as moment from 'moment';

@Component({
  selector: 'app-free-plan-extend',
  templateUrl: './free-plan-extend.component.html',
  styleUrls: ['./free-plan-extend.component.scss']
})
export class FreePlanExtendComponent implements OnInit {
  subscription_end_date: string = ''
  plan_extend_popup_type: number = 0;
  freePlanExtendPopType = freePlanExtendPopType;
  free_plan_extension_days: number = 7;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private configurationService: ConfigurationService,
    private authService: AuthService,
    private dialogRef: MatDialogRef<FreePlanExtendComponent>,
    private notificationService: NotificationsService
  ) {}

  ngOnInit(): void {
    this.plan_extend_popup_type = this.data?.freePlanExtendType;
    this.free_plan_extension_days = this.data?.free_plan_extension_days;
    this.subscription_end_date = moment(this.data?.subscriptionEndDate).add(this.free_plan_extension_days, 'days').format(DATE_EXTEND_FORMAT);
  }

  loginShareIndia() {
    if(this.plan_extend_popup_type === freePlanExtendPopType.Failed) {
      this.notificationService.markPersistantNotificationsAsRead(this.data?.notificationId).subscribe();
    }
    
    this.configurationService.getServerConfig().subscribe((res) => {
      const url = res.config_params.SIGNUP_URL;
      const code = Utils.searchQueryParam(url, 'referral');
      const userName = this.authService.accessTokenObj?.clientId;
      this.authService.initSocialLogin(SocialLoginProvider.SHARE_INDIA, true).then(pr => {
        pr.subscribe((res) => {
          const authLink = Utils.addParamToStringUrl(res.auth_link, 'referral', `${code}-${userName}`);
          location.replace(authLink);
        });
      });
    });
  }

  closeDialog() {
    if (this.plan_extend_popup_type === freePlanExtendPopType.Failed ||
      this.plan_extend_popup_type === freePlanExtendPopType.Success) {
        this.notificationService.markPersistantNotificationsAsRead(this.data?.notificationId).subscribe();
    }
    this.dialogRef.close();
    StorageHelper.freePlanExtendedPopupAccepted = true;
  }
}
